import { ScoreCardEvaluatorsService } from 'api-clients/monolith/services/ScoreCardEvaluatorsService';
import { useCallback } from 'react';

import { useApiService } from 'hooks/useApiService';

// The server returns nothing under three characters, so the request only
// fires once a query can match.
export const SEARCH_MIN_LENGTH = 3;

export const useEvaluatorSearch = (
  templateId: number,
  applicantId: string,
  query: string,
) => {
  const trimmed = query.trim();
  const searchUsers = useCallback(
    () =>
      ScoreCardEvaluatorsService.getInternalApiScoreCardsTemplatesApplicantsEvaluatorsSearch(
        templateId,
        applicantId,
        trimmed,
      ),
    [templateId, applicantId, trimmed],
  );

  return useApiService(searchUsers, {
    enabled:
      Number.isFinite(templateId) &&
      Boolean(applicantId) &&
      trimmed.length >= SEARCH_MIN_LENGTH,
  });
};
